const container = document.querySelector('.catalog');
const scrollAnchor = container.querySelectorAll('a');
scrollAnchor.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault(); 

    const target = document.querySelector(link.getAttribute('href'));
    const offset = target.offsetTop;
    const offsetAmount = -80;

    window.scrollTo({
      top: offset + offsetAmount,
      behavior: 'smooth'
    });
  });
});
